/**
 * Centralised matcher for the public, no-login "Share proposal" routes.
 *
 * These routes must bypass BOTH the app chrome (SideBar/Header/RouteGuard in
 * _app.tsx) AND the employee auth gate (AuthenticationProvider). Keeping the
 * match in one place keeps those two wiring points in sync.
 *
 * Matches Next.js `router.pathname` (the route pattern, not the resolved URL),
 * e.g. "/share/proposal/[token]" and "/share/proposal/view".
 */
export const isSharedProposalRoute = (pathname: string | undefined): boolean =>
  !!pathname && pathname.startsWith("/share/proposal")
